import React from "react";
import { Cog } from "lucide-react";
import { formatNumber, formatBerries, formatRate } from "../game/formatters";

// Small wheel icon (reused in stats)
const WheelIcon = ({ size = 22, color = "#FFD400" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
    <circle cx="12" cy="12" r="10" stroke={color} strokeWidth="1.5" />
    <circle cx="12" cy="12" r="2" fill={color} />
    {Array.from({ length: 6 }).map((_, i) => (
      <line
        key={i}
        x1="12"
        y1="12"
        x2="12"
        y2="3"
        stroke={color}
        strokeWidth="1.2"
        transform={`rotate(${i * 60} 12 12)`}
      />
    ))}
  </svg>
);

const BerryIcon = ({ size = 22 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24">
    <circle cx="12" cy="12" r="10" fill="#FFD400" />
    <circle cx="12" cy="12" r="10" stroke="#111" strokeWidth="1.5" fill="none" />
    <text
      x="12"
      y="16"
      textAnchor="middle"
      fontFamily="Orbitron"
      fontSize="12"
      fontWeight="900"
      fill="#111"
    >
      B
    </text>
  </svg>
);

const Row = ({ icon, label, value, testId }) => (
  <div className="flex items-center gap-3 sm:gap-4 px-4 sm:px-5 py-2.5 sm:py-3.5" data-testid={testId}>
    <div className="flex-shrink-0 w-8 h-8 sm:w-9 sm:h-9 flex items-center justify-center">
      {icon}
    </div>
    <div className="flex-1 min-w-0">
      <div
        className="text-[9px] sm:text-[10px] uppercase tracking-[0.25em] sm:tracking-[0.3em] text-white/60 leading-tight"
        style={{ fontFamily: "Orbitron, sans-serif" }}
      >
        {label}
      </div>
      <div
        className="text-xl sm:text-2xl md:text-3xl font-black text-white leading-tight truncate"
        style={{ fontFamily: "Orbitron, sans-serif" }}
      >
        {value}
      </div>
    </div>
  </div>
);

export const StatsCard = ({ wheelsBuilt, berries, production }) => {
  return (
    <div
      className="w-full max-w-md relative"
      style={{
        backgroundColor: "#0d0d0d",
        border: "1px solid #FFD400",
        borderRadius: 4,
      }}
      data-testid="stats-card"
    >
      {/* Corner brackets */}
      <CornerBrackets />
      <Row
        icon={<WheelIcon size={22} />}
        label="Wheels Built"
        value={formatNumber(wheelsBuilt)}
        testId="stats-wheels-built"
      />
      <div className="h-px w-full" style={{ backgroundColor: "#1f1f1f" }} />
      <Row
        icon={<BerryIcon size={22} />}
        label="Berries"
        value={formatBerries(berries)}
        testId="stats-berries"
      />
      <div className="h-px w-full" style={{ backgroundColor: "#1f1f1f" }} />
      <Row
        icon={<Cog size={22} color="#FFD400" />}
        label="Berry Production"
        value={<span style={{ color: "#FFD400" }}>+{formatRate(production)} <span className="text-sm text-white/60">BERRY/S</span></span>}
        testId="stats-production"
      />
    </div>
  );
};

const CornerBrackets = () => (
  <>
    <span
      aria-hidden
      className="absolute -top-px -left-px w-4 h-4 border-t-2 border-l-2"
      style={{ borderColor: "#FFD400" }}
    />
    <span
      aria-hidden
      className="absolute -top-px -right-px w-4 h-4 border-t-2 border-r-2"
      style={{ borderColor: "#FFD400" }}
    />
    <span
      aria-hidden
      className="absolute -bottom-px -left-px w-4 h-4 border-b-2 border-l-2"
      style={{ borderColor: "#FFD400" }}
    />
    <span
      aria-hidden
      className="absolute -bottom-px -right-px w-4 h-4 border-b-2 border-r-2"
      style={{ borderColor: "#FFD400" }}
    />
  </>
);

export default StatsCard;
